<!-- 配件信息 -->
<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="终端主机号"
             style="width: 200px; margin-right: 3px;"></Input>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onExportExcelClick">导出</Button>
<!--      <Button size="small" type="primary" style="margin-right: 3px;" @click="addPositioningDeviceInfoModal=true">-->
<!--        添加配件信息-->
<!--      </Button>-->

      <Button size="small" type="primary" style="margin-right: 3px;" @click="uploadExcel=true">批量导入配件信息</Button>
<!--      <Upload style="display: inline-block;max-height: 23.99px;margin-right: 3px;" :on-success="onUploadSuccess"-->
<!--              action="/api/im/positioningdevicefitting/uploadpositioningdevicefittingsfile">-->
<!--        <Button size="small" type="primary">批量导入配件信息</Button>-->
<!--      </Upload>-->

      <Dropdown v-if="positioningDeviceFittingList.length > 1" size="small" style="margin-right: 3px" @on-click="DropdownonBitchClick">
        <Button  size="small" type="primary">
          批量操作
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="positioningdevicefittingChangeInstallerModal">批量绑定安装维修员</DropdownItem>
          <DropdownItem name="positioningdevicefittingChangeUsergroupModal">批量分配分组</DropdownItem>
<!--          <DropdownItem name="modifypositioningdevicefittingfactoryGuaranteePeriodmodal">批量修改厂家配件质保期</DropdownItem>-->
<!--          <DropdownItem name="modifypositioningdevicefittingClientGuaranteePeriodmodal">批量修改客户配件质保期</DropdownItem>-->
        </DropdownMenu>
      </Dropdown>

    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange"
                 @contextmenu.prevent.native="onTableRightClick($event)"
                 @on-selection-change="onselectionchange"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator
              @on-change="setPage" show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <add-positioning-device-info-modal v-model="addPositioningDeviceInfoModal"
                                       @on-success="onSuccess"></add-positioning-device-info-modal>
    <positioning-device-fitting-detail-modal v-model="positioningDeviceFittingDetailModal"
                                          :initValue="positioningDeviceFittingDetailId"
                                          @on-success="onModifySuccess"></positioning-device-fitting-detail-modal>
    <assemble-positioning-device-info-modal v-model="assemblePositioningDeviceInfoModal" :initValue="assemblePositioningDeviceInfoId"
                        @on-success="onModifySuccess"></assemble-positioning-device-info-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                             v-model="webTableColumnsModal" @on-column-update="onColumnUpdate"></web-table-columns-modal>

    <positioning-device-fitting-change-installer-modal v-model="positioningDeviceFittingChangeInstallerModal" :initValue="positioningDeviceFittingChangeInstallerId" :listValue="positioningDeviceFittingList" @on-success="onModifySuccess"></positioning-device-fitting-change-installer-modal>
    <positioning-device-fitting-change-usergroup-modal v-model="positioningDeviceFittingChangeUsergroupModal" :initValue="positioningDeviceFittingChangeUsergroupId" :listValue="positioningDeviceFittingList" @on-success="onModifySuccess"></positioning-device-fitting-change-usergroup-modal>
    <modify-positioning-device-fitting-factory-guarantee-period-modal v-model="ModifyPositioningDeviceFittingFactoryGuaranteePeriodModal" :initValue="ModifyPositioningDeviceFittingFactoryGuaranteePeriodId" @on-success="onSuccess"></modify-positioning-device-fitting-factory-guarantee-period-modal>
    <modify-positioning-device-fitting-client-guarantee-period-modal v-model="ModifyPositioningDeviceFittingModifyPositioningDeviceFittingClientGuaranteePeriodModalModal" :initValue="ModifyPositioningDeviceFittingModifyPositioningDeviceFittingClientGuaranteePeriodModalId" @on-success="onSuccess"></modify-positioning-device-fitting-client-guarantee-period-modal>

    <Modal
      v-model="uploadExcel"
      title="批量导入配件信息"
      @on-ok="ok"
      @on-cancel="cancel"
      cancel-text=""
      width="300">

      <Upload style="display: inline-block;max-height: 23.99px;margin-right: 3px;" :on-success="onUploadSuccess" action="/api/im/positioningdevicefitting/uploadpositioningdevicefittingsfile">
        <Button size="small" type="primary">选择文件</Button>
      </Upload>

      <Button v-if="EXCELSrc" type="primary" size="small" @click="downloadTemple(EXCELSrc)" style="margin: 10px;">下载导入模板</Button>

    </Modal>

  </div>
</template>

<script>
import AddPositioningDeviceInfoModal from '@/view/im/components/add-positioning-device-info-modal'
import PositioningDeviceFittingDetailModal from '@/view/im/components/positioning-device-fitting-detail-modal'
import AssemblePositioningDeviceInfoModal from '@/view/im/components/assemble-positioning-device-info-modal'
import PositioningDeviceFittingChangeInstallerModal from '@/view/im/components/positioningdevicefitting-change-installer-modal'
import PositioningDeviceFittingChangeUsergroupModal from '@/view/im/components/positioningdevicefitting-change-usergroup-modal'
import ModifyPositioningDeviceFittingFactoryGuaranteePeriodModal from '@/view/im/components/modify-positioning-device-fitting-factory-guarantee-period-modal'
import ModifyPositioningDeviceFittingModifyPositioningDeviceFittingClientGuaranteePeriodModalModal from '@/view/im/components/modify-positioning-device-fitting-client-guarantee-period-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
import { genURLParams } from '@/libs/urlparamhelper'
import Quicklygeneratecertificate
  from './components/quickly-generate-certificate-modal/quickly-generate-certificate-modal'

export default {
  name: 'positioningdeviceinfos',
  components: {
    AssemblePositioningDeviceInfoModal,
    AddPositioningDeviceInfoModal,
    PositioningDeviceFittingDetailModal,
    PositioningDeviceFittingChangeInstallerModal,
    PositioningDeviceFittingChangeUsergroupModal,
    ModifyPositioningDeviceFittingFactoryGuaranteePeriodModal,
    ModifyPositioningDeviceFittingModifyPositioningDeviceFittingClientGuaranteePeriodModalModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      sourceTypeFilter: null,
      positioningDeviceFittingsTypeFilter: null,
      positioningDeviceFittingFirstOrderTypeFilter: null,
      manufacturerFilter: null,
      userGroupFilter: null,
      installerFilter: null,

      positioningDeviceInfoStateOptions: [
        { label: '未安装', value: 1 },
        { label: '已安装', value: 2 },
        { label: '损坏', value: 3 }
      ],
      positioningDeviceFittingTypeOptions: [],
      positioningDeviceFittingFirstOrderTypeOptions: [],
      manufacturerInfoOptions: [],
      positioningDeviceSourceTypeOptions: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 }
      ],

      // 添加配件信息
      addPositioningDeviceInfoModal: false,

      // 定位设备信息详细信息
      positioningDeviceFittingDetailModal: false,
      positioningDeviceFittingDetailId: null,

      // 配件绑定设备主机
      assemblePositioningDeviceInfoModal: false,
      assemblePositioningDeviceInfoId: null,

      // 配件信息绑定安装维修员
      positioningDeviceFittingChangeInstallerModal: false,
      positioningDeviceFittingChangeInstallerId: null,

      // 配件信息绑定分组
      positioningDeviceFittingChangeUsergroupModal: false,
      positioningDeviceFittingChangeUsergroupId: null,

      // 修改厂家配件质保期
      ModifyPositioningDeviceFittingFactoryGuaranteePeriodModal: null,
      ModifyPositioningDeviceFittingFactoryGuaranteePeriodId: null,

      // 修改客户配件质保期
      ModifyPositioningDeviceFittingModifyPositioningDeviceFittingClientGuaranteePeriodModalModal: null,
      ModifyPositioningDeviceFittingModifyPositioningDeviceFittingClientGuaranteePeriodModalId: null,

      uploadExcel: false,
      // 导入模板地址
      EXCELSrc: '/ERP/im/upload-fittingExcel.xlsx',

      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 100
        },
        {
          title: '主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          width: 150,
          render: function (h, params) {
            if (params.row.positioningDeviceInfo) {
              let positioningDeviceInfo = params.row.positioningDeviceInfo
              return h('div', positioningDeviceInfo.terminalNum)
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '主机芯片码',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          width: 150,
          render: function (h, params) {
            if (params.row.positioningDeviceInfo) {
              let positioningDeviceInfo = params.row.positioningDeviceInfo
              return h('div', positioningDeviceInfo.encryptionChipNumber)
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '芯片码、序列号、S/N',
          resizable: true,
          key: 'encryptionChipNumber',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '配件型号',
          resizable: true,
          key: 'positioningDeviceFittingsType',
          tooltip: 'true',
          ellipsis: 'true',
          width: 250,
          filters: [],
          filterMultiple: false,
          filterRemote: (val) => {
            this.positioningDeviceFittingsTypeFilter = []
            val.forEach(item => {
              if (item == null) {
                this.positioningDeviceFittingsTypeFilter.push(genQueryParam('positioningDeviceFittingsTypeId', 'EQNULL'))
              } else {
                this.positioningDeviceFittingsTypeFilter.push(genQueryParam('positioningDeviceFittingsTypeId', 'EQ', item))
              }
            })
          },
          render: function (h, params) {
            if (params.row.positioningDeviceFittingsType) {
              let positioningDeviceFittingsType = params.row.positioningDeviceFittingsType
              return h('div', positioningDeviceFittingsType.name)
            } else {
              return h('div', '未知')
            }
          }
        },
        {
          title: '配件类型',
          resizable: true,
          key: 'positioningDeviceFittingsType',
          tooltip: 'true',
          ellipsis: 'true',
          width: 110,
          filters: [],
          filterMultiple: false,
          filterRemote: (val) => {
            this.positioningDeviceFittingFirstOrderTypeFilter = []
            val.forEach(item => {
              if (item == null) {
                this.positioningDeviceFittingFirstOrderTypeFilter.push(genQueryParam('positioningDeviceFittingFirstOrderTypeId', 'EQNULL'))
              } else {
                this.positioningDeviceFittingFirstOrderTypeFilter.push(genQueryParam('positioningDeviceFittingFirstOrderTypeId', 'EQ', item))
              }
            })
          },
          render: function (h, params) {
            if (params.row.positioningDeviceFittingsType) {
              if (params.row.positioningDeviceFittingsType.positioningDeviceFittingFirstOrderType) {
                let positioningDeviceFittingFirstOrderType = params.row.positioningDeviceFittingsType.positioningDeviceFittingFirstOrderType
                return h('div', positioningDeviceFittingFirstOrderType.name)
              } else {
                return h('div', '未知')
              }
            } else {
              return h('div', '未知')
            }
          }
        },
        {
          title: '配件厂家',
          resizable: true,
          key: 'manufacturer',
          ellipsis: 'true',
          width: 250,
          filters: [],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.manufacturerFilter = genQueryParam('manufacturerInfoId', 'EQ', val[0])
            } else {
              this.manufacturerFilter = null
            }
          },
          render: function (h, params) {
            if (params.row.manufacturerInfo) {
              let manufacturerInfo = params.row.manufacturerInfo
              return h('div', manufacturerInfo.name)
            } else {
              return h('div', '未知')
            }
          }
        },
        {
          title: '设备来源',
          resizable: true,
          key: 'sourceType',
          ellipsis: 'true',
          width: 120,
          filters: [
            {
              label: '新装',
              value: 1
            },
            {
              label: '接入',
              value: 2
            }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.sourceTypeFilter = genQueryParam('sourceType', 'EQ', val[0])
            } else {
              this.sourceTypeFilter = null
            }
          },
          render: function (h, params) {
            let sourceType = params.row.sourceType
            if (sourceType === 1) {
              return h('div', '新装')
            } else if (sourceType === 2) {
              return h('div', '接入')
            }
          }
        },
        {
          title: '安装车辆',
          resizable: true,
          key: 'vehicleInfoId',
          ellipsis: 'true',
          width: 180,
          render: function (h, params) {
            if (!params.row.positioningDeviceInfo) {
              return h('div', '无')
            }
            if (!params.row.positioningDeviceInfo.vehicleInfo) {
              return h('div', '无')
            }
            let vehicleInfo = params.row.positioningDeviceInfo.vehicleInfo
            let display = null
            if (vehicleInfo.registrationNum) {
              display = vehicleInfo.registrationNum
            } else {
              display = vehicleInfo.vin
            }
            if (vehicleInfo.customName) {
              display = display + '(' + vehicleInfo.customName + ')'
            }
            return h('div', display)
          }
        },
        {
          title: '绑定安装订单',
          resizable: true,
          key: 'installOrderId',
          ellipsis: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.positioningDeviceInfo) {
              if (params.row.positioningDeviceInfo.installOrder) {
                return h('div', params.row.positioningDeviceInfo.installOrder.orderNum)
              }
            }
          }
        },
        {
          title: '厂家配件质保期',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'factoryGuaranteePeriod',
          width: 180,
          render: function (h, params) {
            if (params.row.factoryGuaranteePeriod) {
              let d = new Date(params.row.factoryGuaranteePeriod)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '客户配件质保期',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'clientGuaranteePeriod',
          width: 180,
          render: function (h, params) {
            if (params.row.clientGuaranteePeriod) {
              let d = new Date(params.row.clientGuaranteePeriod)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '分组',
          resizable: true,
          key: 'userGroup',
          // sortable: 'custom',
          ellipsis: 'true',
          width: 120,
          filters: [
            { label: '中山', value: 1 },
            { label: '江门', value: 2 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.userGroupFilter = []
              val.forEach(item => {
                if (item == null) {
                  this.userGroupFilter.push(genQueryParam('userGroupId', 'EQNULL'))
                } else {
                  this.userGroupFilter.push(genQueryParam('userGroupId', 'EQ', item))
                }
              })
            } else {
              this.userGroupFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            if (params.row.userGroup) {
              return h('div', params.row.userGroup.name)
            } else {
              return h('div', '未分配')
            }
          }
        },
        {
          title: '金额',
          resizable: true,
          key: 'talAmount',
          ellipsis: 'true',
          tooltip: 'true',
          width: 100
        },
        {
          title: '安装维修员',
          resizable: true,
          key: 'installer',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.installerFilter = []
              val.forEach(item => {
                if (item == null) {
                  this.installerFilter.push(genQueryParam('installerId', 'EQNULL'))
                } else {
                  this.installerFilter.push(genQueryParam('installerId', 'EQ', item))
                }
              })
            } else {
              this.installerFilter = null
            }
            // this.setPage(1)
          },
          render: (h, params) => {
            if (params.row.installer) {
              let name = null
              if (params.row.installer.realName != null) {
                name = params.row.installer.realName
              } else if (params.row.installer.nickName != null) {
                name = params.row.installer.nickName
              } else if (params.row.installer.name != null) {
                name = params.row.installer.name
              }
              return h('div', name)
            } else {
              return h('div', {
                style: {
                  color: 'red'
                }
              }, '未分配')
            }
          }
        },
        {
          title: '备注',
          resizable: true,
          key: 'remark',
          ellipsis: 'true',
          tooltip: 'true',
          width: 100
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '历史记录',
          resizable: true,
          key: 'historyRecord',
          ellipsis: 'true',
          tooltip: 'true',
          minWidth: 100
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 230,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.positioningDeviceFittingDetailId = params.row.id
                    this.positioningDeviceFittingDetailModal = true
                  }
                }
              }, '详细信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.positioningDeviceFittingChangeInstallerId = params.row.id
                    this.positioningDeviceFittingChangeInstallerModal = true
                  }
                }
              }, '绑定师傅')
              // h('Button', {
              //   props: {
              //     type: 'primary',
              //     size: 'small',
              //     disabled: false
              //   },
              //   style: {
              //     marginRight: '5px'
              //   },
              //   on: {
              //     click: () => {
              //       this.assemblePositioningDeviceInfoId = params.row.id
              //       this.assemblePositioningDeviceInfoModal = true
              //     }
              //   }
              // }, '绑定主机')
            ])
          }
        }
      ], // cloumn

      positioningDeviceFittingList: [],
      positioningDeviceFittingIds: [],
      positioningDeviceFittingModifyPositioningDeviceFittingClientGuaranteePeriodModal: null,
      positioningDeviceFittingFactoryGuaranteePeriod: null
    }// return
  }, // data
  methods: {
    ...mapActions([
      'PositioningDeviceInfoServ_GetPage'
    ]),
    /**
     * 批量选择功能
     */
    onselectionchange (selection) {
      // console.log(selection)
      this.positioningDeviceFittingList = selection
      if (selection.length > 0) {
        selection.forEach(item => {
          this.positioningDeviceFittingIds.push(item.id)
        })
      } else {
        this.positioningDeviceFittingIds = []
      }
      // console.log(this.installOrderList.length)
    },
    handleSelectAll (status) {
      console.log(status)
      this.$refs.table.selectAll(status)
    },
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.filterChange(this.pageFilter)
    },
    onUploadSuccess (rsp) {
      if (rsp.code === 200) {
        this.$Message.success(rsp.msg)
        this.$Message.success('导入成功')
        this.setPage(1)
      } else {
        this.$Message.error(rsp.msg)
      }
    },
    downloadTemple (e) {
      console.log(e)
      window.location.href = e
    },
    onModifySuccess () {
      this.refreshPage()
    },
    onFilterClick () {
      this.setPage(1)
    },
    onExportExcelClick () {
      // let queryParams = []
      // let qo1 = null
      // let qo2 = null
      // if (this.stateFilter) {
      //   qo1 = this.stateFilter
      // }
      // if (this.offlineFilter) {
      //   qo2 = this.offlineFilter
      // }
      // if (this.selectAnalysisDatetime[0] && this.selectAnalysisDatetime[1]) {
      //   let startDatetime = new Date(this.selectAnalysisDatetime[0]).Format('yyyy-MM-dd 00:00:00')
      //   let endDatetime = new Date(this.selectAnalysisDatetime[1]).Format('yyyy-MM-dd 23:59:59')
      //   queryParams.push(genQueryParam('analyzeDatetime', 'BTDT', startDatetime, endDatetime))
      // }
      console.log('AA')
      let urlparams = {
        keyword: this.keywordFilter
      }
      let url = '/api/im/positioningdevicefitting/exportexcel' + genURLParams(urlparams)
      window.location.href = url
    },
    DropdownonBitchClick (name) {
      if (name != null) {
        if (name == 'positioningdevicefittingChangeInstallerModal') {
          console.log('批量绑定师傅')
          this.positioningDeviceFittingChangeInstallerModal = true
          this.positioningDeviceFittingChangeInstallerId = this.positioningDeviceFittingIds
        } else if (name == 'positioningdevicefittingChangeUsergroupModal') {
          console.log('批量分配分组')
          this.positioningDeviceFittingChangeUsergroupModal = true
          this.positioningDeviceFittingChangeUsergroupId = this.positioningDeviceFittingIds
        } else if (name == 'modifypositioningdevicefittingfactoryGuaranteePeriodmodal') {
          console.log('批量厂家')
          this.ModifyPositioningDeviceFittingFactoryGuaranteePeriodModal = true
          this.ModifyPositioningDeviceFittingFactoryGuaranteePeriodId = this.positioningDeviceFittingIds
        } else if (name = 'modifypositioningdevicefittingClientGuaranteePeriodmodal') {
          console.log('批量客户')
          this.ModifyPositioningDeviceFittingModifyPositioningDeviceFittingClientGuaranteePeriodModalModal = true
          this.ModifyPositioningDeviceFittingModifyPositioningDeviceFittingClientGuaranteePeriodModalId = this.positioningDeviceFitting.id
        }
      }
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    filterChange () {
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null
      let qo5 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      if (this.sourceTypeFilter) {
        queryParams.push(this.sourceTypeFilter)
      }
      if (this.positioningDeviceFittingsTypeFilter) {
        qo1 = this.positioningDeviceFittingsTypeFilter
      }

      if (this.positioningDeviceFittingFirstOrderTypeFilter) {
        qo2 = this.positioningDeviceFittingFirstOrderTypeFilter
      }
      if (this.manufacturerFilter) {
        qo3 = this.manufacturerFilter
      }
      if (this.userGroupFilter) {
        qo4 = this.userGroupFilter
      }
      if (this.installerFilter) {
        qo5 = this.installerFilter
      }

      store.dispatch('PositioningDeviceFittingServ_GetPage', {
        params: null,
        urlparams: {
          qo1: qo1,
          qo2: qo2,
          qo3: qo3,
          qo4: qo4,
          qo5: qo5,
          q: queryParams,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
        this.onColumnUpdate()
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '配件型号') {
          this.columns[i].filters = this.positioningDeviceFittingTypeOptions
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '配件类型') {
          this.columns[i].filters = this.positioningDeviceFittingFirstOrderTypeOptions
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '配件厂家') {
          this.columns[i].filters = this.manufacturerInfoOptions
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '安装维修员') {
          this.columns[i].filters = this.installers
          break
        }
      }
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_PositioningDeviceFitting_GetPageResult) {
        return store.getters.get_PositioningDeviceFitting_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_PositioningDeviceFitting_GetPageResult) {
        return store.getters.get_PositioningDeviceFitting_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_PositioningDeviceFitting_GetPageResult) {
        return store.getters.get_PositioningDeviceFitting_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [8, 14] }
      }).then(() => {
        let installers = store.getters.get_User_GetAllUsersResult
        this.installers = installers.map(item => {
          return { label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id }
        })
      }).catch(err => {
        this.$Message.error(err)
      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }

      store.dispatch('PositioningDeviceFittingsTypeServ_GetAll', {
        params: {},
        urlparams: null
      }).then(() => {
        let positioningDeviceFittingTypeOptions = store.getters.get_PositioningDeviceFittingsType_GetAllResult
        if (store.getters.get_PositioningDeviceFittingsType_GetAllResult) {
          this.positioningDeviceFittingTypeOptions = positioningDeviceFittingTypeOptions.map(item => {
            return { label: item.name, value: item.id }
          })
        }
        this.setPage(1)
      }).catch(err => {
        console.log(err)
      })
    })
  }
}
</script>

<style scoped>
</style>
